<template>
  <SwpLayout
    product="ViMengenCloud"
    :isLoading="isLoading"
    :hasError="hasError"
    :errorDescription="errorDescription"
    :isInitialized="props.isInitialized"
  >
    <template v-slot:content>
      <div class="page-content">
        <slot />
      </div>
    </template>
    <template v-slot:top>
      <SwpSidebarLink
        v-if="featureStore.hasFeature('Projects')"
        icon="fas fa-laptop-house"
        text="Projekte"
        :to="{ name: 'ProjectTreeView' }"
        :alternateActiveRouteNames="['SelectTemplateForProjectView', 'ProjectView']"
      />
      <SwpSidebarLink
        v-if="featureStore.hasFeature('Templates')"
        icon="swp-icon-vorlagen"
        text="Vorlagen"
        :to="{ name: 'TemplateTreeView' }"
        :alternateActiveRouteNames="['TemplateView', 'TemplatePreviewView', 'TemplateReadView']"
      />
      <SwpSidebarLink
        v-if="featureStore.hasFeature('Texts')"
        icon="fas fa-align-left"
        text="Firmentexte"
        :to="{ name: 'CompanyTextsView' }"
      />
      <SwpSeparatorLine v-if="featureStore.hasFeature('CommonTemplates')" />
      <SwpSidebarLink
        v-if="featureStore.hasFeature('CommonTemplates')"
        icon="fas fa-archive"
        text="Standardvorlagen"
        :to="{ name: 'CommonTemplateTreeView' }"
        :alternateActiveRouteNames="['CommonTemplateView', 'CommonTemplatePreviewView']"
      />
    </template>
  </SwpLayout>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useLoadingStore } from '@swpsoftware/commons-vue';
import { useFeatureStore } from '@/stores/FeatureStore';
import { SwpSidebarLink, SwpLayout } from '@swpsoftware/commons-layout';
import { SwpSeparatorLine } from '@swpsoftware/vue-components';

const props = defineProps<{ isInitialized: boolean }>();

const featureStore = useFeatureStore();

const { isLoading, hasError, errorDescription } = storeToRefs(useLoadingStore());
</script>

<style lang="scss">
@import '@swpsoftware/vue-components/dist/breakpoints.scss';

.content-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(var(--doc-height) - 60px);

  .tree-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-items: stretch;
    height: 100%;
    flex-shrink: 1;
    min-height: 0;
  }
}

@media screen and (min-width: $breakpoint-lg) {
  .page-content {
    padding: 20px 20px 0 20px;

    .content-wrapper {
      height: calc(var(--doc-height) - 71px);
      gap: 20px;
    }
  }
}
</style>
